import { render, staticRenderFns } from "./OnboardingFooter.vue?vue&type=template&id=ce27db9e&scoped=true&"
import script from "./OnboardingFooter.vue?vue&type=script&lang=js&"
export * from "./OnboardingFooter.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingFooter.vue?vue&type=style&index=0&id=ce27db9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce27db9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCard,VCardActions,VDialog,VDivider,VSnackbar})
